var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        centered: "",
        "hide-footer": "",
        "hide-header": "",
        "body-class": "p-0 rounded registration-modal",
        size: "lg",
        "no-close-on-backdrop": "",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end position-absolute w-100 p-2",
        },
        [
          _c("ci-button", {
            staticClass: "text-dark",
            attrs: {
              id: "close-button",
              variant: "ghost-light",
              icon: "mdi-close",
              iconClass: "mdi-24px",
            },
            on: { click: _vm.closeModal },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row m-0 justify-content-between" },
        [
          _c("ci-registration-form", {
            attrs: {
              "gating-banner-location": _vm.gatingBannerLocation,
              "onboarding-type": _vm.trackingOnboardingType,
              "return-button-text": _vm.returnButtonText,
              "close-modal": _vm.closeModal,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }